export default __webpack_public_path__ + "static/B0066-04471215aee8bfcc90d8626d7761e8ff.png";